<script lang="ts">
    import { getContext, onDestroy } from 'svelte'

    import { gettext as _, resolve } from 'hydria/services/gettext'
    import { simpleFetch } from 'hydria/services/session'
    import { sanchor, spath } from 'hydria/svelte_helpers'

    import type { DomainHandler } from './domain'

    import Date from 'hydria/components/Date.svelte'
    import PageList from 'hydria/components/PageList.svelte'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let ready = $state(false)
    let loading = $state(false)
    let domainLog: Array<any> | undefined = $state()
    let nItems = $state(0)
    let skip = $state(0)

    const Domain = getContext('Domain') as DomainHandler

    // const status = sderived(Domain.status, ($status) => $status)
    let status = $state()
    unsubs.push(
        Domain.status.subscribe(($status) => {
            status = $status
            if (status == 'ready') loadLog()
            else domainLog = undefined
        }),
    )

    async function loadLog() {
        loading = true

        try {
            const res = await simpleFetch('GET', `/json/domain/1/${Domain.idna}/log`, { skip: skip, limit: 10 })

            domainLog = res.data.items
            nItems = res.data.total_items
        } catch {}
        loading = false
        if (!ready) ready = true
    }
</script>

{#if ready}
    <div class="card">
        <div class="card-title text-primary">
            <span>{$_('Modification log')}</span>
            <span><a use:sanchor href={spath(`/domain/${Domain.idna}/revision-diff`)} class="btn btn-sm btn-outline-primary">Compare revisions</a></span>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-condensed table-striped fixed-no-overflow domain-log-table">
                    <thead>
                        <tr>
                            <th>{$_('Date')}</th>
                            <th>{$_('Modification')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if domainLog}
                            {#each domainLog as entry}
                                <tr data-entry-id={entry.id}>
                                    <td><Date value={entry.stamp} format="h-table-s" server={true} /></td>
                                    <td>{$resolve(entry.comment_i18n)}</td>
                                </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer text-bg-light">
            <PageList
                {loading}
                {nItems}
                limit={10}
                {skip}
                setSkip={(e) => {
                    skip = e
                    loadLog()
                }}
            />
        </div>
    </div>
{/if}
